import { asyncPreactWidget } from '../../utils/async-preact-widget';
import { asyncModule } from '../../utils/async-module';
import * as JSModules from '../../components/modules';
import * as preactWidgets from '../../preact/widgets';
import { analyticsFrom } from '../../utils/analytics-from';

export const asyncParselyRender = () => {
  const $element = document.querySelector('#parselyTopNews');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.parselyRenderModule);
    start();
    import('../../components/templating/parsely-render').then(getInit()).catch(error);
  }
};

export const asyncParselyMyTeam = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.parselyMyTeam);
  if (isOnPage()) {
    start();
    import(`../../preact/widgets/parsely-my-team`).then(hydrate).catch(error);
  }
};

export const asyncParselyMySport = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.parselyMySport);
  if (isOnPage()) {
    start();
    import(`../../preact/widgets/parsely-my-sport`).then(hydrate).catch(error);
  }
};

export const asyncParselyMyLocalNews = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.parselyMyLocalNews);
  if (isOnPage()) {
    start();
    import(`../../preact/widgets/parsely-my-local-news`).then(hydrate).catch(error);
  }
};

export const asyncParselyRenderRailMostViewed = () => {
  const $element = document.querySelector('#parselyTopVideos');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.parselyRenderRailMostViewedModule);
    start();
    import('../../components/templating/parsely-render-rail-most-viewed').then(getInit($element)).catch(error);
  }
};

export const asyncAnalyticsFrom = () => {
  const analyticsFromValue = analyticsFrom.get();
  if (analyticsFromValue) {
    const { start, getInit, error } = asyncModule(JSModules.analyticsFromModule);
    start();
    import('../../components/analytics-from/analytics-from').then(getInit(analyticsFromValue)).catch(error);
    analyticsFrom.clean();
  }
};

export const asyncAudioTagTracking = () => {
  const $element = document.querySelector('.s-audio-tag');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.audioTagsTrackingModule);
    start();
    import('../../components/audio-tag/audio-tag-tracking').then(getInit($element)).catch(error);
  }
};
